/** @jsx jsx */
import { jsx } from '@emotion/react';
import { CSSProperties, FC, useEffect } from 'react';
import Select, { components, Props, Theme } from 'react-select';
import { useTranslation } from 'react-i18next';
import { lightViolet, softGrey, greyOnGreyText, greyInput, inputBackground } from '@/components/common/palette';
import { customStyles } from '@/components/form/select';
import { LangKey, getLanguage, LANGUAGE_OPTIONS } from '@/utils/language';
import LanguageIcon from '@/assets/svgs/language';
import { selectBasicStyle } from '@/components/paybylink/styles';
import { StorageKey, clientSetStorage } from '@/utils/localStorage';
import { event, Action, Category, Label } from '@/utils/analytics/google';
import { airTracker } from '@/utils/airTracker';

const Control = ({ children, ...rest }: any) => (
  <components.Control {...rest}>
    <LanguageIcon />
    {children}
  </components.Control>
);

export const Index: FC<Props> = ({ ...props }) => {
  const { i18n } = useTranslation();
  useEffect(() => {
    getLanguage();
  }, []);

  const selectValue = LANGUAGE_OPTIONS.find((option) => option.value === i18n.language);

  const styles: any = {
    ...customStyles,
    ...selectBasicStyle,
    control: (provided: CSSProperties) => ({
      ...provided,
      minHeight: 40,
      background: inputBackground,
      border: `1px solid ${softGrey}`,
      paddingLeft: '16px',
      paddingRight: '8px',
    }),
  };

  return (
    <Select
      {...props}
      components={{
        Control,
      }}
      isSearchable
      name="language"
      options={LANGUAGE_OPTIONS}
      styles={styles}
      theme={(theme: Theme) => ({
        ...theme,
        borderRadius: 4,
        fontSize: 14,
        colors: {
          ...theme?.colors,
          primary25: lightViolet,
          primary: lightViolet,
          neutral20: softGrey,
          neutral30: greyOnGreyText,
          neutral80: greyInput,
        },
      })}
      onChange={(option: any) => {
        if (option?.value) {
          airTracker.updateCommonData({ lang: option?.value });
          airTracker.info('changeLanguage', { prev: getLanguage(), new: option?.value });
          i18n.changeLanguage(option.value as LangKey);
          clientSetStorage(StorageKey.LANG_KEY, option.value);
          event(Category.LanguageSelector, Action.Switch, Label.SelectLanguage);
        }
      }}
      value={selectValue}
    />
  );
};

export default Index;
